import { Box, Card, Typography } from "@mui/material";
import React from "react";
export function SweetPotatoChilli() {
  return (
    <Card sx={{ backgroundColor: "#bbbbbb" }}>
      <Typography variant="h1">Sweet Potato Chilli</Typography>

      <Typography>
        <Typography variant="h3">Ingredients</Typography>6 Sweet Potatoes{" "}
        <br></br>1 tsp cumin seeds <br></br>
        95g jar Chipotle chilli paste<br></br>
        500g chopped mixed veg <br></br>
        3x400g tins black beans<br></br>
        3x400g tins plum tomatoes<br></br>
        60g feta cheese<br></br>
      </Typography>

      <Typography>
        Preheat the oven to 180C. Put a large deep casserole pan on a medium
        high heat.<br></br>
        Peel the sweet potatoes, placing them in the pan as you go. add 1tbsp of
        oil and fry for 5 minutes, turning occasionally, until starting to get
        golden.<br></br>
        Push to one side, add the cumin, let it sizzle, then spoon in the jar of
        chipotle chilli paste and add 2 jars' worth of water.<br></br>
        Tip in the chopped mix veg.<br></br>
        Bake for one hour<br></br>
        <br></br>
        Remove from the oven and add the beans, juice and all, then the
        tomatoes, scrunching them in through clean hands, along with 1 tin's
        worth of water.<br></br>
        Stir well, the roast for another hour, or until the sweet potatoes are
        tender.<br></br>
        Season to perfection, then crumble over the feta to serve.<br></br>
      </Typography>
    </Card>
  );
}
